
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[...landing]",
      function () {
        return require("private-next-pages/page/[...landing].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/[...landing]"])
      });
    }
  